import {Component} from '@angular/core';
import {NgFor, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-services-terapia-fisica',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgFor
  ],
  templateUrl: './services-terapia-fisica.component.html',
  styleUrl: './services-terapia-fisica.component.css'
})
export class ServicesTerapiaFisicaComponent {

  services = [
    {
      "nameEspecialidad": "Traumatología"
    }, {
      "nameEspecialidad": "Ondas de choque"
    }, {
      "nameEspecialidad": "Presoterapia"
    }, {
      "nameEspecialidad": "Masoterapia"
    }, {
      "nameEspecialidad": "Parafinaterapia"
    }, {
      "nameEspecialidad": "Termoterapia"
    }, {
      "nameEspecialidad": "Ultrasonido"
    }, {
      "nameEspecialidad": "Terapia del dolor"
    }, {
      "nameEspecialidad": "Terapia descontracturante"
    }, {
      "nameEspecialidad": "Magnoterapia"
    }, {
      "nameEspecialidad": "Rehabilitación física"
    }, {
      "nameEspecialidad": "Láser"
    },
  ]

}
